import { render } from "./tinyEditor.vue?vue&type=template&id=75f1e502&ts=true"
import script from "./tinyEditor.vue?vue&type=script&lang=ts"
export * from "./tinyEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__